import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Users, Apple, BookOpen, NotebookText, Stethoscope, Palette, UserPlus } from "lucide-react";
import { toast } from "sonner";

export default function AdminDashboard() {
  const [data, setData] = useState(null);
  useEffect(() => {
    api.get("/admin/overview").then(({ data }) => setData(data)).catch((e) => toast.error(formatApiError(e)));
  }, []);
  if (!data) return <div className="text-muted-foreground">Loading…</div>;

  const stats = [
    { label: "Dietitians", value: data.total_dietitians, icon: Stethoscope, testid: "stat-dietitians" },
    { label: "Patients", value: data.total_patients, icon: Users, testid: "stat-patients" },
    { label: "Diet Plans", value: data.total_plans, icon: NotebookText, testid: "stat-plans" },
    { label: "Recipes", value: data.total_recipes, icon: BookOpen, testid: "stat-recipes" },
    { label: "Foods", value: data.total_foods, icon: Apple, testid: "stat-foods" },
  ];

  return (
    <div className="space-y-8" data-testid="admin-dashboard">
      <header>
        <p className="text-xs uppercase tracking-[0.2em] text-primary font-semibold">Super admin</p>
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight mt-1">System overview</h1>
        <p className="text-muted-foreground mt-2">Manage dietitians and the app's look & feel.</p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-5 gap-4">
        {stats.map((s) => {
          const Icon = s.icon;
          return (
            <div key={s.label} className="nt-stat" data-testid={s.testid}>
              <div className="flex items-center justify-between">
                <span className="nt-label">{s.label}</span>
                <Icon size={16} className="text-primary" />
              </div>
              <div className="text-3xl font-bold">{s.value}</div>
            </div>
          );
        })}
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <Link to="/admin/dietitians" className="nt-card p-6 hover:border-primary transition-colors" data-testid="card-dietitians">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-secondary text-secondary-foreground flex items-center justify-center"><UserPlus size={22} /></div>
            <div>
              <h2 className="font-semibold">Manage dietitians</h2>
              <p className="text-sm text-muted-foreground">Add, edit, reset passwords, remove</p>
            </div>
          </div>
        </Link>
        <Link to="/admin/branding" className="nt-card p-6 hover:border-primary transition-colors" data-testid="card-branding">
          <div className="flex items-center gap-3">
            <div className="w-12 h-12 rounded-xl bg-secondary text-secondary-foreground flex items-center justify-center"><Palette size={22} /></div>
            <div>
              <h2 className="font-semibold">Branding & theme</h2>
              <p className="text-sm text-muted-foreground">Colors, fonts, logos, login copy</p>
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
}
